import * as React from "react";
import { useContext, useMemo } from "react";
import HighlightingRulesContext from "views/components/contexts/HighlightingRulesContext";
import Highlight from "./Highlight";
const extractDecorators = ({
  fieldName,
  fieldValue,
  highlightingRules = []
}) => highlightingRules.filter((rule) => rule.field === fieldName).find((rule) => rule.conditionFunc(fieldValue, rule.value));
const CustomHighlighting = ({ children = void 0, field: fieldName, value: fieldValue = void 0 }) => {
  const highlightingRules = useContext(HighlightingRulesContext);
  const matchingRule = useMemo(
    () => extractDecorators({
      fieldName,
      fieldValue,
      highlightingRules
    }),
    [fieldName, fieldValue, highlightingRules]
  );
  return matchingRule ? /* @__PURE__ */ React.createElement(Highlight, { color: matchingRule.color.colorFor(fieldValue) }, children) : children;
};
export default CustomHighlighting;
